import React, { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';
import { AppContext } from '../../../Store';
import styles from '../../../css/components/main-wrappers/hero.css';
import { getAssetUrl } from '../../../helpers/get-asset-url';

function Hero() {

	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const state = useContext(AppContext)[0];
	const hasVideo = onelpsParams.hero.video.hasVideo;
	const videoType = onelpsParams.hero.video.videoType;
	const shouldBlur = onelpsParams.preLander?.show && !state.preLanderCompleted;

	let productVideo = undefined;

	if (hasVideo) {
		try {
			productVideo = getAssetUrl() + require('../../../video/' + GAMEID + '/' + onelpsParams.hero.video.src);
		} catch (error) {
			console.error('Failed to load video:', error);
			productVideo = undefined;
		}
	}

	const hasImage = onelpsParams.hero.image.hasImage;

	const backgroundPosterImage = hasImage && (getAssetUrl() + require('../../../img/' + GAMEID + '/backgrounds/' + onelpsParams.hero.image.src));
	const isRacePageVisible = onelpsParams.raceSelection.show &&
		onelpsParams.raceSelection.type === 'page' &&
		state.showRaceSelection;

	return (
		<section
			data-testid={hasVideo ? 'video-container' : 'image-container'}
			className={hasImage ? `${styles.fullScreenWrapper}` : ''}
		>

			{hasImage && !isRacePageVisible && (

				<div
					data-testid="poster-element"
					className={`${styles.posterElementFullScreen} ${shouldBlur ? styles.blurred : ''}`}
					data-file={onelpsParams.hero.image.src}
					style={{ backgroundImage: 'url(' + backgroundPosterImage + ')' }}
				>
				</div>

			)}

			{hasVideo && !isRacePageVisible && (

				<video
					data-testid="video-element"
					className={`${styles.videoWrapper} ${shouldBlur ? styles.blurred : ''}`}
					poster={getAssetUrl() + require('../../../img/' + GAMEID + '/backgrounds/' + onelpsParams.hero.video.posterSrc)}
					data-file={onelpsParams.hero.video.posterSrc}
					loop="loop"
					muted="muted"
					autoPlay
				>
					<source
						data-testid='source-container'
						src={productVideo}
						data-file={onelpsParams.hero.video.src}
						type={videoType}
					/>
				</video>

			)}

		</section>
	);
}

export default Hero;
